
export default class HttpUtils{
    /**
     * 发送post请求
     * @param {vue 中的this对象} _this 
     * @param {请求地址} url 
     * @param {请求参数} paramsData 
     * @param {回调函数} callBackfun 
     */
    sendPost(_this,url,paramsData,callBackfun)
    {
        let requestTime= (new Date()).getTime();
       
        //url=url+"&sign="+sign;
        let config = {
            
            headers: { 
                
            },
        }
        _this.$http
            .post(url,paramsData,config)
            .then(response => {
                let result=response.data;
                callBackfun(true,result);
            })
            .catch(function (error) { // 请求失败处理
                console.error(error);
                //alert("获取表单数据错误"+error);
                callBackfun(false,error);
            });
    }
    
    /**
     * 发送get请求
     * @param {vue 中的this对象} _this 
     * @param {请求地址} url 
     * @param {请求参数} paramsData 
     * @param {回调函数} callBackfun 
     */
    sendGet(_this,url,params = {},callBackfun)
    {
       
        url.indexOf('?') === -1 ? url = url+'?_='+(new Date().getTime()) : url = url+'&_='+(new Date().getTime());
        _this.$http
            .get(url,{
                params: params,
                headers: {
                }
              })
            .then(response => {
                let result=response.data;
                callBackfun(true,result);
            })
            .catch(function (error) { // 请求失败处理
                console.error(error);
                //alert("获取表单数据错误"+error);
                callBackfun(false,error);
            });
    }

    

}
